export default "__VITE_ASSET__cc999f70__"